export default {
  read: {
    title: "Personal profile",
    subtitle: "Here you can set up your personal profile",
    steps: {
      products: "Products",
      orders: "Orders"
    },
    form: {
      image: {
        label: "Profile picture",
        help: "180x60, max 25MB"
      },
      name: "Name",
      surname: "Surname",
      email: "Email address",
      phone: "Phone no.",
      password: {
        label: "Change password",
        help: "Enter your new password"
      },
      discountCode: "Discount code"
    }
  }
};
